import { styled } from '@mui/material';

export const Video = styled('video')`
  width: 100%;
  height: 100%;
  object-fit: contain;

  background-color: green;
`;
